export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "society",
      layout: "dashboard",
    },
    path: "/societies",
    name: "societies",
    component: () => import("@/layouts/index/SocietyIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "societies",
          layout: "dashboard",
        },
        path: "index",
        name: "societies-index",
        component: () => import("@/views/societies/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer les informations de votre société",
          layout: "dashboard",
        },
        path: "create",
        name: "societies-create",
        component: () => import("@/views/societies/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier la société",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "societies-edit",
        component: () => import("@/views/societies/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails de la société",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "societies-details",
        component: () => import("@/views/societies/Details.vue"),
      },
    ],
  },
];
